import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calculator } from 'lucide-react';

interface RefundReportSummaryProps {
  totalCost: number;
  totalRefund: number;
  currency: string;
}

export const RefundReportSummary: React.FC<RefundReportSummaryProps> = ({
  totalCost,
  totalRefund,
  currency,
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2">
          <Calculator className="h-5 w-5" />
          Summary
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Total Cost */}
          <div className="flex flex-col items-center justify-center p-6 bg-muted/50 rounded-lg">
            <span className="text-sm font-medium text-muted-foreground mb-2">
              Total Cost
            </span>
            <span className="text-3xl font-bold text-foreground tabular-nums">
              {formatCurrency(totalCost)} {currency}
            </span>
          </div>

          {/* Total Refund */}
          <div className="flex flex-col items-center justify-center p-6 bg-primary/10 rounded-lg border-2 border-primary">
            <span className="text-sm font-medium text-muted-foreground mb-2">
              Total Refund
            </span>
            <span className="text-3xl font-bold text-primary tabular-nums">
              {formatCurrency(totalRefund)} {currency}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
